import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { FooterFacade } from '../../../domain/facates/footer-themes.facades';




@Component({
  selector: 'app-footer-four',
  templateUrl: './footer-four.component.html',
  styleUrls: ['./footer-four.component.css']
})
export class FooterFourComponent implements OnInit {


  site_name: string = environment.site_name;
  help_center: string = '';
  email_support: string = '';
  hot_line: string = '';


  constructor(
    private facade: FooterFacade
  ) { }

  ngOnInit(): void
  {


    // get website attributes
    this.get_web_attributes();


  }




  get_web_attributes()
  {

    this.facade.get_site_theme();

    this.facade.site_theme_selector$.subscribe(
      (state)=>{
console.log(state)
        this.help_center = state['help_center'];
        this.email_support = state['email_support'];
        this.hot_line = state['hot_line'];

      }
    );


  }



}
